import { IFirebaseConfig } from '../Types/Database/FirebaseConfig.type';

/**
 * Configuração de ambiente do front-end (ponto único de leitura de variáveis).
 *
 * IMPORTANTE: estas variáveis usam o prefixo REACT_APP_ do Create React App e são
 * embutidas no bundle em TEMPO DE BUILD (`npm run build`). Ou seja, o arquivo .env
 * NÃO precisa subir para produção — apenas os arquivos gerados em /build (dist)
 * carregam os valores já embutidos.
 *
 * Como tudo aqui é embutido no JavaScript público, NÃO trate nada disto como
 * segredo de verdade. Para segredos reais, mantenha-os atrás do back-end.
 *
 * Veja .env.example para a lista completa de variáveis.
 */

const get = (name: string, fallback = ''): string => {
    const value = process.env[name];
    if (value === undefined || value === '') {
        if (!fallback) {
            console.warn(`[env] Variável de ambiente ${name} não definida.`);
        }
        return fallback;
    }
    return value;
};

// URL base da API interna (back-end). Ex.: http://localhost:3001/api/v1
export const API_URL = get('REACT_APP_API_URL', 'http://localhost:3001/api/v1');

// API de gestão Rheostec
export const RHEOSTEC_API_URL = get(
    'REACT_APP_RHEOSTEC_API_URL',
    'https://apigestao.macrolub.com.br:2087/gestao?tipo=leitura',
);
export const RHEOSTEC_TOKEN = get('REACT_APP_RHEOSTEC_TOKEN');

// Configuração do Firebase (a config web é pública por design)
export const firebaseConfig: IFirebaseConfig = {
    apiKey: get('REACT_APP_FIREBASE_API_KEY'),
    authDomain: get('REACT_APP_FIREBASE_AUTH_DOMAIN'),
    projectId: get('REACT_APP_FIREBASE_PROJECT_ID'),
    storageBucket: get('REACT_APP_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: get('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
    appId: get('REACT_APP_FIREBASE_APP_ID'),
    measurementId: get('REACT_APP_FIREBASE_MEASUREMENT_ID'),
};
